export enum Messages {
    OPERATION_SUCCESS = "operacja przebiegła pomyślnie"
}